import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useMediaQuery, Box, Typography, Container } from '@mui/material';

const Day2BranchWise = () => {
  const labels = [
    "MECH", "EE", "ECE", "CSE", "EP", "CIV", "MINING", "MME", "CHEM", "ENVIRO",
    "MLMTE", "M&C", "MTECH CSE", "MTECH MECH", "Double Major Enviro+CSE", "BTECH MLMTE+M.TECH", "Double Major EE + CSE", "MTECH CHEM",
    "MTECH PETRO", "MSC TECH AGL", "MSC TECH AGP"
  ];
  const data = [7, 16, 20, 16, 2, 7, 5, 6, 3, 3, 4, 4, 1, 2, 1, 1, 1, 1, 1, 1, 4];

  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const isMediumScreen = useMediaQuery('(max-width:900px)');
  
  const chartWidth = isSmallScreen ? 300 : isMediumScreen ? 600 : 1400;
  const chartHeight = isSmallScreen ? 200 : 600;

  const chartSetting = {
    xAxis: [
      {
        label: 'Number of Students',
      },
    ],
    width: chartWidth,
    height: chartHeight,
    margin: {
      left: isSmallScreen ? 80 : 170,  // Reduced left margin on small screens
      right: isSmallScreen ? 40 : 60,   // Reduced right margin on small screens
    },
  };

  return (
    <Container maxWidth="lg" sx={{ textAlign: 'center', paddingY: 4 }}>
      <Typography variant="h4" gutterBottom>
        Branch Wise Placements - Day 2
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <BarChart
          dataset={data.map((value, index) => ({ month: labels[index], value }))}
          yAxis={[
            {
              scaleType: 'band',
              dataKey: 'month',
              tickRotation: isSmallScreen ? 45 : 0,
              tickSize: 10,
              tickPadding: 5,
            },
          ]}
          series={[{ dataKey: 'value', label: 'Number of Students' }]}
          layout="horizontal"
          {...chartSetting}
        />
      </Box>
    </Container>
  );
};

export default Day2BranchWise;
